<template>
  <div>
    <div v-for="(item, index) in arr" :key="index">
      <div class="fx__box fx__active" style="margin-bottom: 10px;">
        <div style="display: flex; justify-content: space-between; align-items: center;" @click="$app.routeMenuTo(item.url)">
          <span >{{ item.name }}</span>
          <div style="display: flex;">
            <span v-if="item.icon" :class="`fa fa-${item.icon}`" style="margin: auto 0; float: right; font-size: 20px; margin-left: 10px;"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      arr: [
        {
          name: "主题设置",
          icon: "angle-right",
          url: "app-pad-uithemais",
        },
        {
          name: "修改密码",
          icon: "angle-right",
          url: "core-accountSetting",
        },
      ],
    };
  },
  methods: {
      execution(url) {
        //   if (url) {
        //     ;
        //   } else {
        //     this.$Message.warning("待开发");
        //   }
        }
  }
};
</script>
<style lang="scss" scoped>
.paduser {
  .paduser_item {
    padding-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    .item__container {
      min-height: 50px;
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .img_box {
      width: 60px;
      height: 60px !important;
      border-radius: 16px;
    }
    .user__right {
      display: flex;
      margin-left: 10px;
      justify-content: space-around;
      flex-flow: column;
      flex-grow: 2;
    }
  }
}
</style>

<style lang="less">
.vertical-center-modal.pad-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: -50px !important;
  }
}
</style>
